"use client";

import React from "react";
import { Loader, CircleCheck as CheckCircle2, CircleAlert as AlertCircle } from 'lucide-react';
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
const industries = ["Industrial Manufacturing", "Aerospace", "Pharmaceutical", "Energy & Power", "Chemical Processing", "Other Hazardous Industry"];
function ContactFormInner() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Alert className="bg-primary/5 border-primary/20 text-foreground py-8 flex flex-col items-center justify-center text-center space-y-4">
        <CheckCircle2 className="size-12 text-primary mb-2" />
        <AlertTitle className="text-2xl font-default font-semibold">Transmission Successful</AlertTitle>
        <AlertDescription className="text-base text-muted-foreground max-w-md">
          {successMessage}
        </AlertDescription>
        <Button onClick={resetForm} variant="outline" className="mt-6">
          Submit Another Inquiry
        </Button>
      </Alert>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-8">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <FormField control={control} name="name" rules={{
        required: "Name is required",
        minLength: {
          value: 2,
          message: "Minimum 2 characters required"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Full Name</FormLabel>
              <FormControl>
                <Input placeholder="Jane Doe" className="bg-background/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Email is required",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Invalid email format"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Corporate Email</FormLabel>
              <FormControl>
                <Input type="email" placeholder="jane.doe@company.com" className="bg-background/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="phone" rules={{
        required: "Phone number is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Direct Line</FormLabel>
              <FormControl>
                <Input type="tel" placeholder="+1 (555) 000-0000" className="bg-background/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="company" rules={{
        required: "Company name is required"
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Organization</FormLabel>
              <FormControl>
                <Input placeholder="Company Name Ltd." className="bg-background/50" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="industry" rules={{
        required: "Please select an industry sector"
      }} render={({
        field
      }) => <FormItem className="md:col-span-2">
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Primary Sector</FormLabel>
              <Select onValueChange={field.onChange} defaultValue={field.value}>
                <FormControl>
                  <SelectTrigger className="bg-background/50 w-full">
                    <SelectValue placeholder="Select industry sector..." />
                  </SelectTrigger>
                </FormControl>
                <SelectContent>
                  {industries.map((industry, i) => <SelectItem key={industry} value={industry} data-index={i}>
                      {industry}
                    </SelectItem>)}
                </SelectContent>
              </Select>
              <FormMessage />
            </FormItem>} />

        <FormField control={control} name="message" rules={{
        required: "Please provide details about your inquiry",
        minLength: {
          value: 10,
          message: "Please provide more detail (min 10 characters)"
        }
      }} render={({
        field
      }) => <FormItem className="md:col-span-2">
              <FormLabel className="font-mono text-xs uppercase tracking-wider text-muted-foreground">Project Details / Inquiry</FormLabel>
              <FormControl>
                <Textarea placeholder="Describe your facility, current risk management challenges, or specific engineering needs..." className="min-h-[150px] bg-background/50 resize-y" {...field} />
              </FormControl>
              <FormMessage />
            </FormItem>} />
      </div>

      {submitError && <Alert variant="destructive">
          <AlertCircle className="size-4" />
          <AlertTitle>Transmission Error</AlertTitle>
          <AlertDescription>{submitError}</AlertDescription>
        </Alert>}

      <div className="flex justify-end pt-4 border-t border-border">
        <Button type="submit" disabled={isSubmitting} size="lg" className="w-full md:w-auto font-mono uppercase tracking-wider text-xs">
          {isSubmitting ? <>
              <Loader className="animate-spin mr-2 size-4" />
              Processing...
            </> : 'Initiate Contact'}
        </Button>
      </div>
    </Form>;
}
export default function IndustriesContact() {
  return;
}